export default () => {
  return {
    microphone: true,
    camera: true,
    isRemoteParticipantOffCamera: false,
    isRemoteParticipantOffAudio: false,
    isRemoteParticipantConnected: false,

    stateZoomToken: null,
    stateZoomVideoClient: null,
    stateActiveZoomStream: null,
  };
};
